import React from "react";

const AnswerNumber = ({ value }) => {
  if (value === null || value === undefined || value === "") {
    return <p className="text-sm italic text-gray-400">No response</p>;
  }
  return (
    <p className="text-sm font-mono text-gray-900 bg-gray-50 border border-gray-200 rounded px-2 py-1 inline-block">
      {value}
    </p>
  );
};

export default AnswerNumber;
